import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { DdtAddonGuard } from '../guards/ddt-addon.guard';
import { PermissionGuard } from '../guards/permission.guard';
import { lazyRouteNamed } from '../lazy-route';

const customersPageRoute = lazyRouteNamed(
  () => import('../../pages/customers/customers-page'),
  'CustomersPage',
);

export const customersRoutes: RouteObject[] = [
  {
    path: RoutesList.CUSTOMERS,
    element: <PermissionGuard permission="CUSTOMERS" />,
    children: [
      {
        path: '',
        element: <DdtAddonGuard />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [
              { index: true, ...customersPageRoute },
              { path: 'new', ...customersPageRoute },
              { path: ':id/edit', ...customersPageRoute },
            ],
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.TRANSPORT_DOCUMENTS,
    element: <PermissionGuard permission="CUSTOMERS" />,
    children: [
      {
        path: '',
        element: <DdtAddonGuard />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [
              {
                index: true,
                ...lazyRouteNamed(
                  () => import('../../pages/transport-documents/transport-documents-page'),
                  'TransportDocumentsPage',
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.TRANSPORT_DOCUMENTS_CREATE,
    element: <PermissionGuard permission="CUSTOMERS" />,
    children: [
      {
        path: '',
        element: <DdtAddonGuard />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [
              {
                index: true,
                ...lazyRouteNamed(
                  () => import('../../pages/transport-documents/create-transport-document-page'),
                  'CreateTransportDocumentPage',
                ),
              },
            ],
          },
        ],
      },
    ],
  },
];
